import { render } from "./BookingView.vue?vue&type=template&id=8b499e4c&scoped=true"
import script from "./BookingView.vue?vue&type=script&lang=js"
export * from "./BookingView.vue?vue&type=script&lang=js"

import "./BookingView.vue?vue&type=style&index=0&id=8b499e4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b499e4c"]])

export default __exports__